import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import store from "./store";
import AuthContext from "~/context/auth";
import AccessContext from "~/context/access";

const app = (
  <Provider store={store}>
    <HelmetProvider>
      <AuthContext>
        <AccessContext>
          <App />
        </AccessContext>
      </AuthContext>
    </HelmetProvider>
  </Provider>
);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(app);
